import script from "./TEditorElement.vue?vue&type=script&lang=js"
export * from "./TEditorElement.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__